const isRecord = (value) => value !== null && typeof value === "object";

const sanitizeSection = (section) => {
  if (!isRecord(section)) {
    return section;
  }

  if (!Object.prototype.hasOwnProperty.call(section, "section_contents")) {
    return section;
  }

  const rawContents = section.section_contents;
  const sectionContents = typeof rawContents === "string" ? rawContents : null;
  return { ...section, section_contents: sectionContents };
};

export const sanitizeLifecycleDocumentPayload = (payload) => {
  if (!isRecord(payload) || !Array.isArray(payload.document_contents)) {
    return payload;
  }

  return {
    ...payload,
    document_contents: payload.document_contents.map(sanitizeSection),
  };
};
